import React from 'react';
import {TextInput, Create, SimpleForm, required, minLength,BooleanInput, ReferenceInput, SelectInput, NumberInput, ImageField, ImageInput} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import BaseListActions from '../BaseListActions';
import {COUNTRIES, CURRENCIES, SMS_PROVIDERS} from '../../consts/Names';

const useStyles = makeStyles((theme: Theme) => ({
   formContainer: {
      width: '80%',
      padding: '0 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));


export const CountriesCreate = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} actions={<BaseListActions basePath={basePath} />}>
         <SimpleForm className={classes.formContainer} redirect="list">

            <TextInput className={classes.textFld} label="Name" source={COUNTRIES.name} />

            <ReferenceInput className={classes.textFld} label="Currency" source={COUNTRIES.currency_id} reference="currencies" validate={[required()]}>
               <SelectInput source={CURRENCIES.id} />
            </ReferenceInput>
            <ImageInput
               className={classes.imageFld}
               multiple={false}
               source={COUNTRIES.flag}
               label="Flag"
               accept="image/*"
               placeholder={<p>Drop your image here</p>}>
                   <ImageField source={'src'} />
            </ImageInput>
            <BooleanInput source={COUNTRIES.visibility} label='Visibility' />
            <NumberInput source={COUNTRIES.min_phone_lenght} />
            <NumberInput source={COUNTRIES.max_phone_lenght} />
            <TextInput className={classes.textFld} label="Phone number mask" source={COUNTRIES.phone_mask} />
            <TextInput className={classes.textFld} label="Country phone code" source={COUNTRIES.phone_code} />
            <ReferenceInput className={classes.textFld} label="Sms Provider" source={COUNTRIES.sms_provider_id}  perPage={500} reference={SMS_PROVIDERS.SOURCE}>
               <SelectInput source={SMS_PROVIDERS.id} />
            </ReferenceInput>
         </SimpleForm>
      </Create>
   );
};
